/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const FILE_ALT_VIEWBOX_W = 16;
const FILE_ALT_VIEWBOX_H = 20;

const FILE_ALT_PATH =
  'M5 8H6C6.26522 8 6.51957 7.89464 6.70711 7.70711C6.89464 7.51957 7 7.26522 7 7C7 6.73478 6.89464 6.48043 6.70711 6.29289C6.51957 6.10536 6.26522 6 6 6H5C4.73478 6 4.48043 6.10536 4.29289 6.29289C4.10536 6.48043 4 6.73478 4 7C4 7.26522 4.10536 7.51957 4.29289 7.70711C4.48043 7.89464 4.73478 8 5 8ZM5 10C4.73478 10 4.48043 10.1054 4.29289 10.2929C4.10536 10.4804 4 10.7348 4 11C4 11.2652 4.10536 11.5196 4.29289 11.7071C4.48043 11.8946 4.73478 12 5 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11C12 10.7348 11.8946 10.4804 11.7071 10.2929C11.5196 10.1054 11.2652 10 11 10H5ZM16 6.94C15.9896 6.84813 15.9695 6.75763 15.94 6.67V6.58C15.8919 6.47718 15.8278 6.38267 15.75 6.3L9.75 0.3C9.66734 0.222216 9.57282 0.158081 9.47 0.11C9.44015 0.10576 9.40985 0.10576 9.38 0.11C9.27841 0.0517412 9.16622 0.0143442 9.05 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H13C13.7956 20 14.5587 19.6839 15.1213 19.1213C15.6839 18.5587 16 17.7956 16 17V7C16 7 16 7 16 6.94ZM10 3.41L12.59 6H11C10.7348 6 10.4804 5.89464 10.2929 5.70711C10.1054 5.51957 10 5.26522 10 5V3.41ZM14 17C14 17.2652 13.8946 17.5196 13.7071 17.7071C13.5196 17.8946 13.2652 18 13 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H8V5C8 5.79565 8.31607 6.55871 8.87868 7.12132C9.44129 7.68393 10.2044 8 11 8H14V17ZM11 14H5C4.73478 14 4.48043 14.1054 4.29289 14.2929C4.10536 14.4804 4 14.7348 4 15C4 15.2652 4.10536 15.5196 4.29289 15.7071C4.48043 15.8946 4.73478 16 5 16H11C11.2652 16 11.5196 15.8946 11.7071 15.7071C11.8946 15.5196 12 15.2652 12 15C12 14.7348 11.8946 14.4804 11.7071 14.2929C11.5196 14.1054 11.2652 14 11 14Z';

/** Default fill from Figma asset. */
export const FILE_ALT_ICON_DEFAULT_FILL = '#61677F';

const iconPropTypes = {
  size: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * File with text lines (16×20). `size` sets rendered height; width scales to aspect ratio.
 * Color via `fill` or CSS `color` + `currentColor`.
 * Pass `aria-label` when icon conveys meaning without adjacent text.
 */
const FileAltIcon = ({
  size = 20,
  fill = 'currentColor',
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const height = size;
  const width = Math.round((size * FILE_ALT_VIEWBOX_W) / FILE_ALT_VIEWBOX_H);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${FILE_ALT_VIEWBOX_W} ${FILE_ALT_VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', 'ds-icon--filled', className].filter(Boolean).join(' ')}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path d={FILE_ALT_PATH} fill={fill} />
    </svg>
  );
};

FileAltIcon.propTypes = iconPropTypes;

export { FileAltIcon };
export default FileAltIcon;
